import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.tcl = bracketIndenting({
	line: "#",
})
